export const ROLES = {
  PROVIDER: 1,
  CLIENT: 2,
  OTHER: 0 
};

export const LOGIN_STATUS = {
  SUCCESS: 2,
  MISMATCH: 1,
  NO_USER: 0
}
 export const CREATE_STATUS = {
  PATCH: 2,
  NEW: 1,
  NOTHING: 0
 }